import type { ButtonHTMLAttributes, ReactNode } from 'react'
import * as stylex from '@stylexjs/stylex'

type ButtonVariant = 'primary' | 'secondary'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode
  variant?: ButtonVariant
}

const styles = stylex.create({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.375rem',
    paddingBlock: '0.5rem',
    paddingInline: '1rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 500,
    transitionProperty: 'color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '150ms',
    cursor: {
      ':disabled': 'not-allowed',
    },
    opacity: {
      ':disabled': 0.5,
    },
  },
  primary: {
    backgroundColor: {
      default: '#0f172a',
      ':hover': '#1e293b',
    },
    color: '#fff',
  },
  secondary: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#cbd5e1',
    backgroundColor: {
      default: '#fff',
      ':hover': '#f8fafc',
    },
    color: '#334155',
  },
})

export default function Button({
  children,
  className = '',
  variant = 'primary',
  type = 'button',
  ...props
}: ButtonProps) {
  const buttonProps = stylex.props(styles.root, styles[variant])

  return (
    <button {...props} className={`${buttonProps.className} ${className}`.trim()} style={{ ...buttonProps.style, ...props.style }} type={type}>
      {children}
    </button>
  )
}
